import React, { FC, memo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { PlusSubscriptionModalSelector } from 'src/store/plusSubscription/selectors';
import { PlusSubscriptionPaymentFailedModal } from 'src/components/plusSubscription/modals/PaymentFailed';
import { stringArrayStartsWith } from 'src/utils/stringArrayStartsWith';
import { PlusSubscriptionModal } from 'src/components/plusSubscription/modals/components/Modal';

export const PlusSubscriptionModals: FC = memo(() => {
  const { type, canClose } = useSelector(PlusSubscriptionModalSelector);

  const { pathname } = useLocation();

  // not show modals on these urls
  if (stringArrayStartsWith(pathname, ['/administration', '/partner', '/account/profile'])) {
    return null;
  }

  switch (type) {
    case 'planSelection':
    case 'upgradeNow':
    case 'trialExpired':
    case 'unlimited':
    case 'planPreselected':
      return <PlusSubscriptionModal type={type} />;
    case 'paymentFailed':
      return <PlusSubscriptionPaymentFailedModal canClose={canClose} />;
    default:
      return null;
  }
});
